import { TRACE_STORE_NAME } from '@/creditflowresearch/application/Trace/constants';
import DatePeriod from '@/creditflowresearch/ui/common/components/organisms/Filters/FiltersPanel/DatePeriod';
import { useTraceFiltersContext } from '@/creditflowresearch/application/Trace/TraceFilters/TraceFiltersContext';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';

const DatePeriodContainer = (props) => {
  const { getFilters } = useFiltersContext();
  const { dateFrom, dateTo } = getFilters(TRACE_STORE_NAME);
  const { dateFromMin, dateToMax } = useTraceFiltersContext();

  return (
    <DatePeriod
      { ...props }
      dateFrom={ dateFrom }
      dateTo={ dateTo }
      dateFromMin={ dateFromMin }
      dateToMax={ dateToMax }
    />
  );
};
export default DatePeriodContainer;
